import {defaultProps} from 'recompose'

import compose from 'lodash/flowRight'
import * as React from 'react'

import {withLocation} from '../../../../routes'
import {PagerGroup} from '../Pager.types'
import PagerWarning from '../PagerWarning/PagerWarning.container'
import type {Props} from '../PagerWarning/PagerWarning.types'

import BuildPagerWarning from './BuildPagerWarning'

function BuildPagerWarningContainer({
  show,
  isShow,
  group,
  pageSize,
  updateResults,
  ...restProps
}: Props) {
  return show ? <BuildPagerWarning {...restProps} /> : null
}

export default compose(
  React.memo,
  defaultProps({
    group: PagerGroup.BUILD,
  }),
  PagerWarning,
  withLocation,
)(BuildPagerWarningContainer)
